module.exports = __webpack_public_path__ + "static/media/Oct1-F18.2db9cde5.png";